// extracted by mini-css-extract-plugin
export default {"container":"rcqb","header":"RLcA","loader":"icLQ","dragNdrop":"aZDp","drag":"Hwqt","leave":"HdF2","dragTitle":"RK4_","text":"Xyd4","fileLoader":"DUqZ"};